import { Tooltip } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button/Button';
import BarChartOutlinedIcon from '@material-ui/icons/BarChartOutlined';
import { useSelector } from 'react-redux';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import routes, { Route } from 'src/constants/routes';
import { t } from 'src/lib/language';
import { Store } from 'src/redux/Store';

interface OwnProps {
  fundraisingId: number;
}

type Props = OwnProps & ButtonProps;

const ShowStatisticsForFundraisingButton = (props: Props) => {
  const { disabled, fundraisingId } = props;
  const lang = useSelector((state: Store) => state.language.language);
  const statisticsPath = routes[Route.FUNDRAISING_STATISTICS].path;

  const onClick = () => {
    if (!fundraisingId) return;
    window.open(statisticsPath.replace(':fundraising_id', String(fundraisingId)));
  };

  return (
    <Tooltip
      title={t(lang, 'menus.show_fundraisings_statistics')}
      placement="top-start">
      <span>
        <ActionButton
          data-testid="show-statistics-button"
          category={MENU_BUTTON_CATEGORY.presets}
          onClick={onClick}
          disabled={disabled}>
          <BarChartOutlinedIcon />
        </ActionButton>
      </span>
    </Tooltip>
  );
};

export default ShowStatisticsForFundraisingButton;
